import { EmailField } from '@shared/data/entity/fields/EmailField';

/** An email field as one line of text: the first address, and a "+N" for any more. */
export function getEmailText(field: EmailField): string {
  const [first = '', ...more] = field.emails;
  return more.length > 0 ? `${first} +${more.length}` : first;
}
